import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { telegramBotKeys } from '../telegramBot.keys';
import { updateTelegramBotConfig } from '../telegramBot.service';
export const useUpdateTelegramBotConfig = (subdomain = getSubdomain()) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (config) => updateTelegramBotConfig(subdomain, config),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: telegramBotKeys.config(subdomain) });
        },
    });
};
